// components/Outreach/WorkerPanel.js — ПОЛНАЯ НОВАЯ ВЕРСИЯ
import React, { useState, useEffect } from "react";
import { getCookie } from "../../services/cookie";
import { HiChevronLeft, HiChevronRight, HiX } from "react-icons/hi";

const API_BASE = "https://flautreach.com/flautreach/api/outreach";

export function WorkerPanel({ add }) {
  const token = () => getCookie("authToken");
  const getHeaders = () => {
    const t = token();
    return { "Content-Type": "application/json", ...(t ? { Authorization: `Bearer ${t}` } : {}) };
  };

  // ========== ВОРКЕРЫ ==========
  const [workers, setWorkers] = useState([]);
  const [loadingWorkers, setLoadingWorkers] = useState(false);
  const [workerPage, setWorkerPage] = useState(1);
  const [workerTotalPages, setWorkerTotalPages] = useState(1);
  const [newWorkerName, setNewWorkerName] = useState("");
  const [newWorkerLimit, setNewWorkerLimit] = useState(50);
  const [addingWorker, setAddingWorker] = useState(false);

  useEffect(() => { loadWorkers(); }, [workerPage]);

  const loadWorkers = async () => {
    setLoadingWorkers(true);
    try {
      const resp = await fetch(`${API_BASE}/workers/?page=${workerPage}&page_size=5`, { headers: getHeaders() });
      if (resp.ok) {
        const data = await resp.json();
        const list = Array.isArray(data) ? data : data.results || [];
        setWorkers(list);
        setWorkerTotalPages(data.pagination?.total_pages || 1);
      }
    } catch (err) {
      add?.("Ошибка загрузки воркеров", "error");
    } finally {
      setLoadingWorkers(false);
    }
  };

  const addWorker = async () => {
    if (!newWorkerName.trim()) { add?.("Введи имя", "error"); return; }
    setAddingWorker(true);
    try {
      const resp = await fetch(`${API_BASE}/workers/`, {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify({ name: newWorkerName.trim(), daily_limit: newWorkerLimit, is_active: true }),
      });
      if (resp.ok) {
        setNewWorkerName("");
        setNewWorkerLimit(50);
        add?.("Воркер добавлен", "success");
        setWorkerPage(1);
        loadWorkers();
      } else {
        const err = await resp.json().catch(() => ({}));
        add?.(err.detail || JSON.stringify(err) || "Ошибка", "error");
      }
    } catch (err) {
      add?.("Ошибка: " + err.message, "error");
    } finally {
      setAddingWorker(false);
    }
  };

  const toggleWorker = async (id, isActive) => {
    try {
      await fetch(`${API_BASE}/workers/${id}/`, {
        method: "PATCH",
        headers: getHeaders(),
        body: JSON.stringify({ is_active: !isActive }),
      });
      add?.(isActive ? "Деактивирован" : "Активирован", "success");
      loadWorkers();
    } catch (err) {
      add?.("Ошибка", "error");
    }
  };

  const changeLimit = async (id, name, currentLimit) => {
    const val = prompt(`Новый daily limit для "${name}":`, currentLimit);
    if (!val) return;
    try {
      await fetch(`${API_BASE}/workers/${id}/`, {
        method: "PATCH",
        headers: getHeaders(),
        body: JSON.stringify({ daily_limit: parseInt(val) }),
      });
      add?.("Лимит изменён", "success");
      loadWorkers();
    } catch (err) {
      add?.("Ошибка", "error");
    }
  };

  const deleteWorker = async (id, name) => {
    if (!window.confirm(`Удалить воркера "${name}"?`)) return;
    try {
      await fetch(`${API_BASE}/workers/${id}/`, { method: "DELETE", headers: getHeaders() });
      add?.("Воркер удалён", "info");
      loadWorkers();
    } catch (err) {
      add?.("Ошибка", "error");
    }
  };

  // ========== РАНДОМ ИНТЕНШЕН ==========
  const [queueCount, setQueueCount] = useState(0);
  const [workerStatsList, setWorkerStatsList] = useState({});
  const [intention, setIntention] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [editedText, setEditedText] = useState("");
  const [editedSubject, setEditedSubject] = useState("");
  const [selectedChannel, setSelectedChannel] = useState("");
  const [sending, setSending] = useState(false);
  const [rerolling, setRerolling] = useState(false);
  const [copiedField, setCopiedField] = useState(null);
  const [selectedWorkerForSend, setSelectedWorkerForSend] = useState(null);
  const [showDialogPrompt, setShowDialogPrompt] = useState(false);

  useEffect(() => { loadQueueCount(); loadAllWorkerStats(); }, [workers]);

  const loadQueueCount = async () => {
    try {
      const resp = await fetch(`${API_BASE}/intentions/?status=PENDING&page_size=1`, { headers: getHeaders() });
      if (resp.ok) {
        const data = await resp.json();
        setQueueCount(data.pagination?.total || 0);
      }
    } catch {}
  };

  const loadAllWorkerStats = async () => {
    const statsMap = {};
    for (const w of workers) {
      if (!w.is_active) continue;
      try {
        const resp = await fetch(`${API_BASE}/worker/queue-stats/?worker_name=${encodeURIComponent(w.name)}`, { headers: getHeaders() });
        if (resp.ok) {
          const data = await resp.json();
          if (data.worker_stats) {
            statsMap[w.id] = data.worker_stats;
          }
        }
      } catch {}
    }
    setWorkerStatsList(statsMap);
  };

  const getRandomIntention = async () => {
    setSending(true);
    try {
      const resp = await fetch(`${API_BASE}/worker/random-intention/`, { headers: getHeaders() });
      if (resp.status === 404) {
        add?.("Нет доступных намерений", "info");
        setSending(false);
        return;
      }
      if (resp.ok) {
        const data = await resp.json();
        setIntention(data);
        const ch = data.candidate_channels?.[0] || "";
        setSelectedChannel(ch);
        updateTextForChannel(data, ch);
        setShowModal(true);
      }
    } catch (err) {
      add?.("Ошибка", "error");
    } finally {
      setSending(false);
    }
  };

  const updateTextForChannel = (intentionData, channel) => {
    const msg = intentionData?.expanded_payload?.[channel] || intentionData?.payload?.[channel];
    if (channel === "EMAIL") {
      setEditedSubject(typeof msg === "object" ? (msg.subject || "") : "");
      setEditedText(typeof msg === "object" ? (msg.body || "") : "");
    } else {
      setEditedSubject("");
      setEditedText(typeof msg === "object" ? (msg.body || "") : (msg || ""));
    }
  };

  const rerollIntention = async () => {
    if (!intention) return;
    setRerolling(true);
    try {
      const resp = await fetch(`${API_BASE}/worker/reroll-intention/`, {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify({ intention_id: intention.id }),
      });
      if (resp.ok) {
        const data = await resp.json();
        setIntention(prev => ({
          ...prev,
          expanded_payload: data.expanded_payload,
        }));
        updateTextForChannel(
          { ...intention, expanded_payload: data.expanded_payload },
          selectedChannel
        );
        add?.("🔄 Текст перераскрыт", "info");
      } else {
        add?.("Ошибка перераскрытия", "error");
      }
    } catch (err) {
      add?.("Ошибка: " + err.message, "error");
    } finally {
      setRerolling(false);
    }
  };

  const confirmSend = async (success = true) => {
    if (!intention) return;
    if (!selectedWorkerForSend) {
      add?.("Выбери воркера перед подтверждением!", "error");
      return;
    }
    setSending(true);
    try {
      const worker = workers.find(w => w.id === selectedWorkerForSend) || 
                     intention.available_workers?.find(w => w.id === selectedWorkerForSend);
      const resp = await fetch(`${API_BASE}/worker/confirm-send/`, {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify({
          intention_id: intention.id,
          worker_name: worker?.name || "",
          channel_used: selectedChannel,
          channel_address: intention.expanded_payload?.[selectedChannel]?.address || intention.target_url || "",
          sent_text: selectedChannel === "EMAIL"
            ? JSON.stringify({ subject: editedSubject, body: editedText })
            : editedText,
          success,
        }),
      });
      
      const result = await resp.json();
      
      if (result.worker_stats) {
        setWorkerStatsList(prev => ({
          ...prev,
          [selectedWorkerForSend]: result.worker_stats,
        }));
        
        if (result.worker_stats.remaining <= 0) {
          add?.("⚠️ Дневной лимит исчерпан!", "error");
        }
      }
      
      add?.(success ? "✅ Отправлено!" : "❌ Ошибка", success ? "success" : "error");
      setShowModal(false);
      setIntention(null);
      setSelectedWorkerForSend(null);
      loadQueueCount();
    } catch (err) {
      add?.("Ошибка", "error");
    } finally {
      setSending(false);
    }
  };

  const skipIntention = () => {
    setIntention(null);
    setSelectedWorkerForSend(null);
    getRandomIntention();
  };

  const closeModal = () => {
    setShowModal(false);
    setIntention(null);
    setSelectedWorkerForSend(null);
    setShowDialogPrompt(false);
  };

  const copyToClipboard = (text, field) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopiedField(field);
      setTimeout(() => setCopiedField(null), 1500);
    }).catch(() => {});
  };

  const getContactInfo = (data) => {
    if (!data) return { email: null, website: null, links: [] };
    const email = data.email || null;
    const website = data.website || null;
    const links = Array.isArray(data.links) ? data.links.filter(l => typeof l === "string" && l.trim()) : [];
    return { email, website, links };
  };

  const makeUrlClickable = (url) => {
    if (!url) return "#";
    if (/^https?:\/\//i.test(url)) return url;
    return "https://" + url;
  };

  const contactInfo = intention ? getContactInfo(intention.target_data) : null;

  // Функция для получения URL скриншота
  const getScreenshotUrl = (screenshotPath) => {
    if (!screenshotPath) return null;
    return `https://flautreach.com/media/${screenshotPath}`;
  };

  // Определяем мобильное устройство
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={{ padding: isMobile ? '10px' : '0' }}>
      {/* ========== СЕКЦИЯ 1: УПРАВЛЕНИЕ ВОРКЕРАМИ ========== */}
      <div className="section-card" style={{ marginBottom: 20 }}>
        <h3 style={{ fontSize: isMobile ? 18 : 24 }}>👷 Управление воркерами</h3>

        <div style={{ 
          display: "flex", 
          gap: isMobile ? 8 : 10, 
          marginBottom: 20, 
          alignItems: "flex-end", 
          flexWrap: "wrap",
          flexDirection: isMobile ? 'column' : 'row'
        }}>
          <div style={{ flex: "1 1 200px", width: isMobile ? '100%' : 'auto' }}>
            <label className="form-label" style={{ marginBottom: 4, fontSize: isMobile ? 13 : 14 }}>Имя воркера</label>
            <input
              className="form-input"
              style={{ paddingLeft: 14, fontSize: isMobile ? 16 : 14 }}
              value={newWorkerName}
              onChange={e => setNewWorkerName(e.target.value)}
              placeholder="Например: worker-1"
              onKeyDown={e => e.key === "Enter" && addWorker()}
            />
          </div>
          <div style={{ width: isMobile ? '100%' : 100 }}>
            <label className="form-label" style={{ marginBottom: 4, fontSize: isMobile ? 13 : 14 }}>Лимит</label>
            <input
              className="form-input"
              style={{ paddingLeft: 14, fontSize: isMobile ? 16 : 14 }}
              type="number"
              value={newWorkerLimit}
              onChange={e => setNewWorkerLimit(parseInt(e.target.value) || 50)}
              min={1}
              max={10000}
            />
          </div>
          <button
            className="btn-add"
            style={{ 
              height: 42, 
              whiteSpace: "nowrap",
              width: isMobile ? '100%' : 'auto',
              fontSize: isMobile ? 16 : 14
            }}
            onClick={addWorker}
            disabled={addingWorker || !newWorkerName.trim()}
          >
            {addingWorker ? "⏳" : "+"} Добавить
          </button>
        </div>

        {loadingWorkers ? (
          <div style={{ textAlign: "center", padding: 20 }}><div className="spinner"/></div>
        ) : workers.length === 0 ? (
          <div className="empty-state" style={{ padding: 20 }}>
            <p>Нет воркеров. Добавь первого!</p>
          </div>
        ) : (
          <>
            <div className="rules-grid" style={{ marginBottom: 12, gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(300px, 1fr))' }}>
              {workers.map(w => {
                const stats = workerStatsList[w.id];
                return (
                  <div key={w.id} className="rule-card" style={{ padding: isMobile ? "12px" : "14px 18px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, flexDirection: isMobile ? 'column' : 'row' }}>
                      <div style={{ flex: 1, width: '100%' }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: 'wrap' }}>
                          <strong style={{ fontSize: isMobile ? 13 : 14 }}>{w.name}</strong>
                          <span style={{
                            fontSize: 11, padding: "2px 8px", borderRadius: 10,
                            background: w.is_active ? "#f0fdf4" : "#fef2f2",
                            color: w.is_active ? "#16a34a" : "#dc2626",
                            fontWeight: 600,
                          }}>
                            {w.is_active ? "✓ Активен" : "✗ Неактивен"}
                          </span>
                        </div>
                        <div style={{ fontSize: isMobile ? 11 : 12, color: "var(--muted)", marginTop: 4 }}>
                          Дневной лимит: <strong>{w.daily_limit || 50}</strong>
                          {stats && (
                            <span style={{ marginLeft: 12, color: stats.remaining <= 0 ? "#dc2626" : "#16a34a" }}>
                              | Отправлено: <strong>{stats.sent_today}/{stats.daily_limit}</strong>
                              {stats.remaining <= 0 && " 🔴"}
                            </span>
                          )}
                        </div>
                      </div>
                      <div style={{ display: "flex", gap: 6, width: isMobile ? '100%' : 'auto', justifyContent: isMobile ? 'space-between' : 'flex-end' }}>
                        <button className="btn-toggle paused" style={{ fontSize: 11, flex: isMobile ? 1 : 'none' }} onClick={() => toggleWorker(w.id, w.is_active)}>
                          {w.is_active ? "⏸" : "▶"}
                        </button>
                        <button className="btn-toggle paused" style={{ fontSize: 11, flex: isMobile ? 1 : 'none' }} onClick={() => changeLimit(w.id, w.name, w.daily_limit)}>
                          ✎ Лимит
                        </button>
                        <button className="btn-delete" style={{ flex: isMobile ? 1 : 'none' }} onClick={() => deleteWorker(w.id, w.name)}>🗑</button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {workerTotalPages > 1 && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 8 }}>
                <button onClick={() => setWorkerPage(p => Math.max(1, p - 1))} disabled={workerPage <= 1}
                  style={{ minWidth: isMobile ? 32 : 36, height: isMobile ? 32 : 36, borderRadius: 8, border: "1.5px solid var(--border)", background: "#fff", cursor: workerPage <= 1 ? "not-allowed" : "pointer", opacity: workerPage <= 1 ? 0.4 : 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <HiChevronLeft size={isMobile ? 16 : 18} />
                </button>
                {Array.from({ length: workerTotalPages }, (_, i) => i + 1).map(p => (
                  <button key={p} onClick={() => setWorkerPage(p)}
                    style={{ minWidth: isMobile ? 32 : 36, height: isMobile ? 32 : 36, borderRadius: 8, border: "none", background: p === workerPage ? "var(--blue)" : "transparent", color: p === workerPage ? "#fff" : "var(--dark)", fontWeight: p === workerPage ? 600 : 400, cursor: "pointer", fontSize: isMobile ? 12 : 14 }}>
                    {p}
                  </button>
                ))}
                <button onClick={() => setWorkerPage(p => Math.min(workerTotalPages, p + 1))} disabled={workerPage >= workerTotalPages}
                  style={{ minWidth: isMobile ? 32 : 36, height: isMobile ? 32 : 36, borderRadius: 8, border: "1.5px solid var(--border)", background: "#fff", cursor: workerPage >= workerTotalPages ? "not-allowed" : "pointer", opacity: workerPage >= workerTotalPages ? 0.4 : 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <HiChevronRight size={isMobile ? 16 : 18} />
                </button>
              </div>
            )}
          </>
        )}
      </div>

      {/* ========== КНОПКА GET RANDOM ========== */}
      <button
        className="btn-primary"
        style={{ 
          width: "100%", 
          padding: isMobile ? "18px" : "24px", 
          fontSize: isMobile ? 16 : 18, 
          fontWeight: 700, 
          letterSpacing: 2 
        }}
        disabled={sending}
        onClick={getRandomIntention}
      >
        {sending ? "⏳ Загрузка..." : "🎲 ПОЛУЧИТЬ РАНДОМНОЕ СООБЩЕНИЕ"}
      </button>
      <div style={{ marginTop: 12, fontSize: isMobile ? 12 : 13, color: "var(--muted)", textAlign: "center" }}>
        В очереди: <strong>{queueCount}</strong> сообщений
      </div>

      {/* ========== МОДАЛКА (АДАПТИВНАЯ) ========== */}
      {showModal && intention && (
        <div style={{ 
          position: "fixed", 
          inset: 0, 
          background: "rgba(0,0,0,0.6)", 
          backdropFilter: "blur(4px)", 
          display: "flex", 
          alignItems: isMobile ? "flex-end" : "center", 
          justifyContent: "center", 
          zIndex: 1000, 
          padding: isMobile ? 0 : "10px" 
        }} onClick={closeModal}>
          <div style={{ 
            background: "#fff", 
            borderRadius: isMobile ? "20px 20px 0 0" : 16, 
            width: "100%", 
            maxWidth: isMobile ? "100%" : "1400px", 
            height: isMobile ? "95vh" : "95vh", 
            display: "flex",
            flexDirection: "column",
            overflow: "hidden", 
            boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
            animation: isMobile ? "slideUp 0.3s ease-out" : "none"
          }} onClick={e => e.stopPropagation()}>
            {/* Заголовок */}
            <div style={{ 
              padding: isMobile ? "12px 16px" : "16px 24px", 
              borderBottom: "1.5px solid var(--border)", 
              display: "flex", 
              justifyContent: "space-between", 
              alignItems: "center",
              flexShrink: 0
            }}>
              <div>
                <h3 style={{ margin: 0, fontSize: isMobile ? 18 : 24 }}>📨 Отправка</h3>
                <p style={{ fontSize: isMobile ? 11 : 13, color: "var(--muted)", marginTop: 4, marginBottom: 0 }}>
                  Кампания: {intention.campaign_name || `#${intention.campaign_id}`}
                </p>
              </div>
              <button
                onClick={closeModal}
                style={{
                  width: isMobile ? 28 : 32, 
                  height: isMobile ? 28 : 32, 
                  borderRadius: 8, 
                  border: "1px solid var(--border)",
                  background: "#fff", 
                  cursor: "pointer", 
                  display: "flex", 
                  alignItems: "center", 
                  justifyContent: "center",
                  color: "var(--muted)", 
                  fontSize: 18, 
                  flexShrink: 0,
                }}
                title="Закрыть"
              >
                <HiX size={isMobile ? 16 : 20} />
              </button>
            </div>

            {/* Скроллируемый контент */}
            <div style={{ 
              flex: 1, 
              overflow: "auto", 
              padding: isMobile ? "16px" : "24px",
              display: "grid",
              gridTemplateColumns: isMobile ? "1fr" : "1fr 400px",
              gap: isMobile ? "16px" : "24px",
              alignItems: "start"
            }}>
              {/* Левая колонка - основная информация */}
              <div style={{ display: "flex", flexDirection: "column", gap: isMobile ? "16px" : "20px" }}>
                {/* Target URL и страна */}
                <div style={{
                  background: "#f8f9ff",
                  border: "1px solid var(--border)",
                  borderRadius: 10,
                  padding: isMobile ? "12px" : "16px"
                }}>
                  <div style={{ display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center" }}>
                    <span style={{ fontSize: isMobile ? 16 : 20 }}>🎯</span>
                    <div style={{ flex: 1, minWidth: isMobile ? "100%" : "200px" }}>
                      <div style={{ fontSize: isMobile ? 11 : 12, color: "var(--muted)", marginBottom: 4 }}>Цель:</div>
                      <a href={intention.target_url} target="_blank" rel="noopener noreferrer"
                         style={{ color: "var(--blue)", textDecoration: "underline", wordBreak: "break-all", fontWeight: 600, fontSize: isMobile ? 13 : 14 }}>
                        {intention.target_url}
                      </a>
                    </div>
                    {intention.target_data?.country && (
                      <div style={{ 
                        display: "flex", 
                        alignItems: "center", 
                        gap: 6, 
                        padding: isMobile ? "4px 10px" : "6px 14px", 
                        background: "#f0f9ff", 
                        borderRadius: 8,
                        fontSize: isMobile ? 12 : 14,
                        fontWeight: 600,
                        color: "#0369a1",
                        border: "1px solid #bae6fd"
                      }}>
                        🌍 {intention.target_data.country}
                      </div>
                    )}
                  </div>
                </div>

                {/* Уже отправлено */}
                {intention.already_sent && intention.already_sent.total_executions > 0 && (
                  <div style={{
                    background: "#fff7ed",
                    border: "1.5px solid #fed7aa",
                    borderRadius: 10,
                    padding: isMobile ? "12px" : "14px 18px",
                  }}>
                    <div style={{ fontWeight: 700, marginBottom: 8, color: "#c2410c", fontSize: isMobile ? 12 : 13 }}>
                      ⚠️ Этому таргету уже отправляли ({intention.already_sent.total_executions} раз)
                    </div>
                    {intention.already_sent.campaigns_sent?.map((item, idx) => (
                      <div key={idx} style={{
                        fontSize: isMobile ? 11 : 12, 
                        padding: "6px 0",
                        borderBottom: idx < intention.already_sent.campaigns_sent.length - 1 ? "1px solid #fed7aa" : "none",
                        color: "#78350f",
                      }}>
                        📢 <strong>{item.campaign_name}</strong> — 👷 {item.worker_name}
                        <span style={{ marginLeft: 8, color: "#9a3412", fontSize: isMobile ? 10 : 11 }}>
                          ({new Date(item.sent_at).toLocaleDateString("ru-RU")})
                        </span>
                      </div>
                    ))}
                    <div style={{ marginTop: 8, fontSize: isMobile ? 10 : 11, color: "#b45309" }}>
                      🚫 Исключены из выбора: {intention.already_sent.workers_sent?.join(", ")}
                    </div>
                  </div>
                )}

                {/* Контакты */}
                <div style={{
                  background: "#fff",
                  border: "1px solid var(--border)",
                  borderRadius: 10,
                  padding: isMobile ? "12px" : "16px"
                }}>
                  <label className="form-label" style={{ marginBottom: 12, fontSize: isMobile ? 13 : 14, fontWeight: 600 }}>🔗 Контакты</label>
                  <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, padding: isMobile ? "6px 8px" : "8px 12px", background: "#f8f9ff", borderRadius: 8, flexWrap: isMobile ? 'wrap' : 'nowrap' }}>
                      <span>📧</span>
                      <span style={{ fontWeight: 600, marginRight: 8, minWidth: isMobile ? "auto" : 60, fontSize: isMobile ? 12 : 13 }}>Email:</span>
                      {contactInfo?.email ? (
                        <>
                          <a href={`mailto:${contactInfo.email}`} style={{ color: "var(--blue)", textDecoration: "underline", wordBreak: "break-all", flex: 1, fontSize: isMobile ? 12 : 13, minWidth: isMobile ? "100%" : "auto" }}>
                            {contactInfo.email}
                          </a>
                          <button onClick={() => copyToClipboard(contactInfo.email, 'email')}
                            style={{ padding: "2px 10px", fontSize: 11, borderRadius: 4, border: "1px solid var(--border)", background: copiedField === 'email' ? "#dcfce7" : "#fff", color: copiedField === 'email' ? "#16a34a" : "var(--muted)", cursor: "pointer" }}>
                            {copiedField === 'email' ? "✓" : "📋"}
                          </button>
                        </>
                      ) : (
                        <span style={{ flex: 1, color: "#9ca3af", fontSize: isMobile ? 12 : 13 }}>—</span>
                      )}
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: 8, padding: isMobile ? "6px 8px" : "8px 12px", background: "#f8f9ff", borderRadius: 8, flexWrap: isMobile ? 'wrap' : 'nowrap' }}>
                      <span>🌐</span>
                      <span style={{ fontWeight: 600, marginRight: 8, minWidth: isMobile ? "auto" : 60, fontSize: isMobile ? 12 : 13 }}>Website:</span>
                      {contactInfo?.website ? (
                        <a href={makeUrlClickable(contactInfo.website)} target="_blank" rel="noopener noreferrer"
                           style={{ color: "var(--blue)", textDecoration: "underline", wordBreak: "break-all", flex: 1, fontSize: isMobile ? 12 : 13, minWidth: isMobile ? "100%" : "auto" }}>
                          {contactInfo.website}
                        </a>
                      ) : (
                        <span style={{ flex: 1, color: "#9ca3af", fontSize: isMobile ? 12 : 13 }}>—</span>
                      )}
                    </div>

                    <div style={{ padding: isMobile ? "6px 8px" : "8px 12px", background: "#f8f9ff", borderRadius: 8 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: contactInfo?.links?.length > 0 ? 6 : 0 }}>
                        <span>🔗</span>
                        <span style={{ fontWeight: 600, fontSize: isMobile ? 12 : 13 }}>Links:</span>
                      </div>
                      {contactInfo?.links?.length > 0 ? (
                        <div style={{ display: "flex", flexDirection: "column", gap: 4, marginLeft: isMobile ? 0 : 28 }}>
                          {contactInfo.links.map((link, idx) => (
                            <div key={idx}>
                              <a href={makeUrlClickable(link)} target="_blank" rel="noopener noreferrer"
                                 style={{ color: "var(--blue)", textDecoration: "underline", wordBreak: "break-all", fontSize: isMobile ? 12 : 13 }}>
                                {link}
                              </a>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <span style={{ color: "#9ca3af", marginLeft: isMobile ? 0 : 28, fontSize: isMobile ? 12 : 13 }}>—</span>
                      )}
                    </div>
                  </div>
                </div>

                {/* Канал */}
                <div>
                  <label className="form-label" style={{ marginBottom: 8, fontSize: isMobile ? 13 : 14, fontWeight: 600 }}>📡 Канал отправки</label>
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    {(intention.candidate_channels || []).map(ch => (
                      <button key={ch} 
                        className={`channel-tab ${selectedChannel === ch ? "active" : ""}`} 
                        onClick={() => {
                          setSelectedChannel(ch);
                          updateTextForChannel(intention, ch);
                        }}
                        style={{
                          padding: isMobile ? "8px 12px" : "10px 16px",
                          fontSize: isMobile ? 13 : 14
                        }}
                      >
                        {ch === "EMAIL" ? "📧" : ch === "FB_MESSENGER" ? "💬" : "📝"} {ch}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Тема (EMAIL) с РЕРОЛЛОМ */}
                {selectedChannel === "EMAIL" && (
                  <div>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8, flexWrap: isMobile ? 'wrap' : 'nowrap', gap: isMobile ? 8 : 0 }}>
                      <label className="form-label" style={{ marginBottom: 0, fontSize: isMobile ? 13 : 14, fontWeight: 600 }}>📋 Тема</label>
                      <div style={{ display: "flex", gap: 8 }}>
                        <button onClick={rerollIntention} disabled={rerolling}
                          style={{ padding: isMobile ? "4px 10px" : "6px 14px", fontSize: isMobile ? 11 : 12, borderRadius: 6, border: "1px solid var(--border)", background: "#fff", cursor: "pointer", display: "flex", alignItems: "center", gap: 4 }}>
                          {rerolling ? "⏳" : "🎲"} Реролл
                        </button>
                        <button onClick={() => copyToClipboard(editedSubject, 'subject')}
                          style={{ padding: isMobile ? "4px 10px" : "6px 14px", fontSize: isMobile ? 11 : 12, borderRadius: 6, border: "1px solid var(--border)", background: copiedField === 'subject' ? "#dcfce7" : "#fff", color: copiedField === 'subject' ? "#16a34a" : "var(--muted)", cursor: "pointer" }}>
                          {copiedField === 'subject' ? "✓" : "📋"}
                        </button>
                      </div>
                    </div>
                    <input className="form-input" style={{ width: "100%", padding: isMobile ? "10px 12px" : "12px 16px", fontSize: isMobile ? 14 : 14 }} value={editedSubject} onChange={e => setEditedSubject(e.target.value)} />
                  </div>
                )}

                {/* Текст с РЕРОЛЛОМ */}
                <div>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8, flexWrap: isMobile ? 'wrap' : 'nowrap', gap: isMobile ? 8 : 0 }}>
                    <label className="form-label" style={{ marginBottom: 0, fontSize: isMobile ? 13 : 14, fontWeight: 600 }}>✍️ Текст</label>
                    <div style={{ display: "flex", gap: 8 }}>
                      <button onClick={rerollIntention} disabled={rerolling}
                        style={{ padding: isMobile ? "4px 10px" : "6px 14px", fontSize: isMobile ? 11 : 12, borderRadius: 6, border: "1px solid var(--border)", background: "#fff", cursor: "pointer", display: "flex", alignItems: "center", gap: 4 }}>
                        {rerolling ? "⏳" : "🎲"} Реролл
                      </button>
                      <button onClick={() => copyToClipboard(editedText, 'body')}
                        style={{ padding: isMobile ? "4px 10px" : "6px 14px", fontSize: isMobile ? 11 : 12, borderRadius: 6, border: "1px solid var(--border)", background: copiedField === 'body' ? "#dcfce7" : "#fff", color: copiedField === 'body' ? "#16a34a" : "var(--muted)", cursor: "pointer" }}>
                        {copiedField === 'body' ? "✓" : "📋"}
                      </button>
                    </div>
                  </div>
                  <textarea className="intent-textarea" style={{ minHeight: isMobile ? 150 : 250, fontSize: isMobile ? 13 : 14, lineHeight: 1.6 }} value={editedText} onChange={e => setEditedText(e.target.value)} />
                </div>

                {/* Промпт диалога */}
                {intention.dialog_prompt && (
                  <div>
                    <button
                      onClick={() => setShowDialogPrompt(!showDialogPrompt)}
                      style={{
                        width: "100%", 
                        padding: isMobile ? "10px" : "12px", 
                        borderRadius: 8,
                        border: "1px solid var(--border)", 
                        background: "#f9fafb",
                        cursor: "pointer", 
                        textAlign: "left", 
                        fontSize: isMobile ? 13 : 14,
                        display: "flex", 
                        justifyContent: "space-between", 
                        alignItems: "center",
                      }}
                    >
                      <span>🤖 Промпт диалога</span>
                      <span style={{ fontSize: isMobile ? 11 : 12, color: "var(--muted)" }}>{showDialogPrompt ? "▲ Скрыть" : "▼ Показать"}</span>
                    </button>
                    {showDialogPrompt && (
                      <div style={{
                        marginTop: 8, 
                        padding: isMobile ? "10px" : "16px",
                        background: "#1e1e2e", 
                        color: "#cdd6f4",
                        borderRadius: 8, 
                        fontSize: isMobile ? 11 : 12,
                        fontFamily: "monospace", 
                        whiteSpace: "pre-wrap",
                        maxHeight: isMobile ? 300 : 400, 
                        overflow: "auto",
                        border: "1px solid #313244",
                        lineHeight: 1.5
                      }}>
                        {intention.dialog_prompt}
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* Правая колонка - скриншот и информация */}
              <div style={{ 
                display: "flex", 
                flexDirection: "column", 
                gap: isMobile ? "16px" : "20px", 
                position: isMobile ? "static" : "sticky", 
                top: isMobile ? "auto" : 0 
              }}>
                {/* Скриншот */}
                {intention.target_data?.screenshot_url && (
                  <div>
                    <label className="form-label" style={{ marginBottom: 8, fontSize: isMobile ? 13 : 14, fontWeight: 600 }}>📸 Скриншот</label>
                    <div style={{
                      border: "1px solid var(--border)",
                      borderRadius: 10,
                      overflow: "hidden",
                      background: "#f9fafb",
                      cursor: "pointer"
                    }}
                    onClick={() => window.open(getScreenshotUrl(intention.target_data.screenshot_url), '_blank')}
                    title="Открыть в новой вкладке">
                      <img 
                        src={getScreenshotUrl(intention.target_data.screenshot_url)}
                        alt="Screenshot"
                        style={{
                          width: "100%",
                          height: "auto",
                          display: "block",
                          maxHeight: isMobile ? "300px" : "600px",
                          objectFit: "contain"
                        }}
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.parentElement.innerHTML = '<div style="padding: 40px; text-align: center; color: #9ca3af;">Скриншот недоступен</div>';
                        }}
                      />
                    </div>
                  </div>
                )}

                {/* Инфо о таргете */}
                {intention.target_data && (
                  <div style={{
                    background: "#f8f9ff",
                    border: "1px solid var(--border)",
                    borderRadius: 10,
                    padding: isMobile ? "12px" : "16px"
                  }}>
                    <div style={{ fontWeight: 700, marginBottom: 12, fontSize: isMobile ? 13 : 14 }}>📊 Информация о таргете</div>
                    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                      {intention.target_data.username && (
                        <div style={{ fontSize: isMobile ? 12 : 13 }}>
                          <strong>Username:</strong> @{intention.target_data.username}
                        </div>
                      )}
                      {intention.target_data.full_name && (
                        <div style={{ fontSize: isMobile ? 12 : 13 }}>
                          <strong>Имя:</strong> {intention.target_data.full_name}
                        </div>
                      )}
                      {intention.target_data.followers && (
                        <div style={{ fontSize: isMobile ? 12 : 13 }}>
                          <strong>Подписчики:</strong> {intention.target_data.followers}
                        </div>
                      )}
                      {intention.target_data.following && (
                        <div style={{ fontSize: isMobile ? 12 : 13 }}>
                          <strong>Подписки:</strong> {intention.target_data.following}
                        </div>
                      )}
                      {intention.target_data.mediacount && (
                        <div style={{ fontSize: isMobile ? 12 : 13 }}>
                          <strong>Постов:</strong> {intention.target_data.mediacount}
                        </div>
                      )}
                      {intention.target_data.bio && (
                        <div style={{ fontSize: isMobile ? 12 : 13, marginTop: 8 }}>
                          <strong>Bio:</strong>
                          <div style={{ 
                            marginTop: 4, 
                            whiteSpace: "pre-wrap",
                            background: "#fff",
                            padding: isMobile ? "8px" : "10px",
                            borderRadius: 6,
                            border: "1px solid var(--border)",
                            maxHeight: isMobile ? 120 : 150,
                            overflow: "auto",
                            fontSize: isMobile ? 11 : 12,
                            lineHeight: 1.5
                          }}>
                            {intention.target_data.bio}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Выбор воркера - ВЫДЕЛЕННЫЙ БЛОК */}
            <div style={{ 
              padding: isMobile ? "12px" : "16px 24px", 
              borderTop: "2px solid var(--blue)",
              background: "#f0f7ff",
              flexShrink: 0
            }}>
              <div style={{ 
                display: "flex", 
                alignItems: isMobile ? "stretch" : "center", 
                gap: isMobile ? 8 : 16,
                flexDirection: isMobile ? "column" : "row"
              }}>
                <label style={{ 
                  fontSize: isMobile ? 14 : 16, 
                  fontWeight: 700, 
                  whiteSpace: isMobile ? "normal" : "nowrap",
                  color: "#1e40af",
                  minWidth: isMobile ? "auto" : "200px"
                }}>
                  👷 Воркер для отправки:
                </label>
                {intention.available_workers && intention.available_workers.length === 0 ? (
                  <div style={{
                    flex: 1,
                    padding: isMobile ? "10px" : "12px 14px", 
                    background: "#fef2f2",
                    border: "1.5px solid #fecaca", 
                    borderRadius: 8,
                    color: "#dc2626", 
                    fontSize: isMobile ? 13 : 14,
                    fontWeight: 600
                  }}>
                    ⚠️ Все доступные воркеры уже отправляли этому таргету или исчерпали лимит!
                  </div>
                ) : (
                  <select
                    className="form-input"
                    style={{ 
                      flex: 1, 
                      padding: isMobile ? "10px 12px" : "14px 20px", 
                      fontSize: isMobile ? 14 : 16,
                      fontWeight: 600,
                      border: "2px solid #3b82f6",
                      borderRadius: 8,
                      background: "#fff",
                      width: "100%"
                    }}
                    value={selectedWorkerForSend || ""}
                    onChange={e => setSelectedWorkerForSend(e.target.value ? parseInt(e.target.value) : null)}
                  >
                    <option value="">-- ВЫБЕРИ ВОРКЕРА --</option>
                    {(intention.available_workers || workers.filter(w => w.is_active)).map(w => (
                      <option key={w.id} value={w.id}>
                        {w.name} (лимит: {w.daily_limit}, осталось: {w.remaining ?? "?"})
                      </option>
                    ))}
                  </select>
                )}
              </div>
            </div>

            {/* Кнопки действий */}
            <div style={{ 
              padding: isMobile ? "12px" : "16px 24px", 
              borderTop: "1.5px solid var(--border)", 
              display: "flex", 
              gap: isMobile ? 8 : 12,
              flexShrink: 0,
              background: "#fff",
              flexWrap: isMobile ? "wrap" : "nowrap"
            }}>
              {isMobile ? (
                <>
                  <button className="btn-cancel" onClick={skipIntention} style={{ flex: 1, padding: "12px 16px", fontSize: 14 }}>⏭ Пропустить</button>
                  <button className="btn-cancel" onClick={() => confirmSend(false)} style={{ color: "#dc2626", borderColor: "#fecaca", padding: "12px 16px", fontSize: 14 }}>❌ Ошибка</button>
                  <button className="btn-primary" style={{ width: "100%", padding: "14px", fontSize: 15 }} disabled={sending || !selectedWorkerForSend} onClick={() => confirmSend(true)}>
                    {sending ? "⏳" : "✅"} Подтвердить отправку
                  </button>
                </>
              ) : (
                <>
                  <button className="btn-cancel" onClick={skipIntention} style={{ padding: "12px 20px", fontSize: 14 }}>⏭ Пропустить</button>
                  <button className="btn-cancel" onClick={() => confirmSend(false)} style={{ color: "#dc2626", borderColor: "#fecaca", padding: "12px 20px", fontSize: 14 }}>❌ Ошибка</button>
                  <button className="btn-primary" style={{ flex: 1, padding: "12px 20px", fontSize: 15 }} disabled={sending || !selectedWorkerForSend} onClick={() => confirmSend(true)}>
                    {sending ? "⏳" : "✅"} Подтвердить отправку
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Добавляем анимацию для мобильной версии */}
      <style jsx>{`
        @keyframes slideUp {
          from {
            transform: translateY(100%);
          }
          to {
            transform: translateY(0);
          }
        }
        
        @media (max-width: 768px) {
          .rules-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </div>
  );
}